/*
 *
 * Form constants
 *
 */

export const DEFAULT_ACTION = "app/Administrator/Companies/Form/DEFAULT_ACTION"

export const GET_COMPANIES_INFO_WATCHER =
  "app/Administrator/Companies/Form/GET_COMPANIES_INFO_WATCHER"
export const GET_COMPANIES_INFO_SUCCESS =
  "app/Administrator/Companies/Form/GET_COMPANIES_INFO_SUCCESS"

export const GET_COMPANIES_SAVE_WATCHER =
  "app/Administrator/Companies/Form/GET_COMPANIES_SAVE_WATCHER"
export const GET_COMPANIES_SAVE_SUCCESS =
  "app/Administrator/Companies/Form/GET_COMPANIES_SAVE_SUCCESS"
export const GET_COMPANIES_SAVE_FAILED =
  "app/Administrator/Companies/Form/GET_COMPANIES_SAVE_FAILED"

export const GET_COMPANY_WATCHER =
  "app/Administrator/Companies/Form/GET_COMPANY_WATCHER"
export const GET_COMPANY_SUCCESS =
  "app/Administrator/Companies/Form/GET_COMPANY_SUCCESS"
export const GET_COMPANY_FAILED =
  "app/Administrator/Companies/Form/GET_COMPANY_FAILED"

export const DELETE_COMPANY_WATCHER =
  "app/Administrator/Companies/Form/DELETE_COMPANY_WATCHER"
export const DELETE_COMPANY_SUCCESS =
  "app/Administrator/Companies/Form/DELETE_COMPANY_SUCCESS"
export const DELETE_COMPANY_FAILED =
  "app/Administrator/Companies/Form/DELETE_COMPANY_FAILED"

export const STATUS_COMPANY_WATCHER =
  "app/Administrator/Companies/Form/STATUS_COMPANY_WATCHER"

export const USERS_COMPANY_WATCHER =
  "app/Administrator/Companies/Form/USERS_COMPANY_WATCHER"
export const USERS_COMPANY_SUCCESS =
  "app/Administrator/Companies/Form/USERS_COMPANY_SUCCESS"
export const USERS_COMPANY_FAILED =
  "app/Administrator/Companies/Form/USERS_COMPANY_FAILED"

export const USERS_SA_SWITCH_WATCHER =
  "app/Administrator/Companies/Form/USERS_SA_SWITCH_WATCHER"
export const USERS_SA_SWITCH_SUCCESS =
  "app/Administrator/Companies/Form/USERS_SA_SWITCH_SUCCESS"
export const USERS_SA_SWITCH_FAILED =
  "app/Administrator/Companies/Form/USERS_SA_SWITCH_FAILED"

export const DELETE_USER_WATCHER =
  "app/Administrator/Companies/Form/DELETE_USER_WATCHER"
export const DELETE_USER_SUCCESS =
  "app/Administrator/Companies/Form/DELETE_USER_SUCCESS"
export const DELETE_USER_FAILED =
  "app/Administrator/Companies/Form/DELETE_USER_FAILED"
  export const GET_USERS_WATCHER =
  "app/Administrator/Companies/Form/GET_USERS_WATCHER"
export const GET_USERS_SUCCESS =
  "app/Administrator/Companies/Form/GET_USERS_SUCCESS"
export const GET_USERS_FAILED =
  "app/Administrator/Companies/Form/GET_USERS_FAILED"

export const VALIDATE_VISMA_PEOPLE_INFO_WATCHER = "app/Administrator/Companies/Form/VALIDATE_VISMA_PEOPLE_INFO_WATCHER"
export const VALIDATE_VISMA_PEOPLE_INFO_SUCCESS = "app/Administrator/Companies/Form/VALIDATE_VISMA_PEOPLE_INFO_SUCCESS"
export const VALIDATE_VISMA_PEOPLE_INFO_FAILED = "app/Administrator/Companies/Form/VALIDATE_VISMA_PEOPLE_INFO_FAILED"

export const VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER = "app/Administrator/Companies/Form/VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER"
export const VALIDATE_VISMA_PEOPLE_STRUCTURE_SUCCESS = "app/Administrator/Companies/Form/VALIDATE_VISMA_PEOPLE_STRUCTURE_SUCCESS"
export const VALIDATE_VISMA_PEOPLE_STRUCTURE_FAILED = "app/Administrator/Companies/Form/VALIDATE_VISMA_PEOPLE_STRUCTURE_FAILED"

export const UPDATE_VALIDATE_VISMA_PEOPLE_REQUESTED = "app/Administrator/Companies/Form/UPDATE_VALIDATE_VISMA_PEOPLE_REQUESTED"
export const UPDATE_VALIDATE_VISMA_PEOPLE_STRUCTURE_REQUESTED = "app/Administrator/Companies/Form/UPDATE_VALIDATE_VISMA_PEOPLE_STRUCTURE_REQUESTED"

export const RESET_COMPANIES_INFO = "app/Administrator/Companies/Form/RESET_COMPANIES_INFO"
export const RESET_VISMA_PEOPLE_VALIDATIONS = "app/Administrator/Companies/Form/RESET_VISMA_PEOPLE_VALIDATIONS"
export const RESET_VISMA_PEOPLE_STRUCTURE_VALIDATIONS = "app/Administrator/Companies/Form/RESET_VISMA_PEOPLE_INFO_VALIDATIONS"